// Whether this visitor has ever opened the widget (persisted across page
// reloads via localStorage). Used to stop nagging with the variant-B teaser
// pills on mobile once the guest has already engaged: after the first open the
// pills never come back — not on close, not on reload.
const WIDGET_OPENED_KEY = "drastik_widget_opened";

export function markWidgetOpened() {
  try {
    localStorage.setItem(WIDGET_OPENED_KEY, "1");
  } catch {
    // No localStorage (privacy mode): pills just keep their default behavior.
  }
}

export function wasWidgetOpened(): boolean {
  try {
    return !!localStorage.getItem(WIDGET_OPENED_KEY);
  } catch {
    return false;
  }
}
